import { render, staticRenderFns } from "./RomaOaModalForm.vue?vue&type=template&id=2259b124"
import script from "./RomaOaModalForm.vue?vue&type=script&lang=ts"
export * from "./RomaOaModalForm.vue?vue&type=script&lang=ts"
import style0 from "./RomaOaModalForm.vue?vue&type=style&index=0&id=2259b124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports